exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer-container[data-v-126b135a]{padding:0.125rem;font-size:0.07292rem;line-height:1.5;word-wrap:break-word}.drawer-container .drawer-title[data-v-126b135a]{margin-bottom:0.0625rem;color:rgba(0,0,0,0.85);font-size:0.07292rem;line-height:0.11458rem}.drawer-container .drawer-item[data-v-126b135a]{color:rgba(0,0,0,0.65);font-size:0.07292rem;padding:0.0625rem 0}.drawer-container .drawer-switch[data-v-126b135a]{float:right}\n", ""]);

// exports
